/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */

export type PayoutRequestStatus = typeof PayoutRequestStatus[keyof typeof PayoutRequestStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayoutRequestStatus = {
  Pending: 'Pending',
  Returned: 'Returned',
  Denied: 'Denied',
  Approved: 'Approved',
} as const;
